import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function refreshSlaSummary() {
  const res = await fetcher(
    `${API_BASE_PATH}/sla/refresh`,
    { method: 'POST' },
    undefined,
  );

  return res;
}
